import { ChangeEvent, InputHTMLAttributes, memo, useMemo } from "react";
import classNames from "classnames";
import { v1 } from "uuid";

import styles from "./style.module.scss";

export type RadioButtonProps = Omit<InputHTMLAttributes<HTMLInputElement>, "onChange" | "value"> & {
  value?: boolean,
  disabled?: boolean,
  onChange?: (e: ChangeEvent<HTMLInputElement>, value: boolean) => void,
  label?: string,
}

const RadioButton = memo<RadioButtonProps>((
  {
    id,
    value = false,
    disabled = false,
    onChange,
    label,
    className,
    style,
    ...restProps
  }) => {
  const realId = useMemo(() => id || v1(), [ id ]);
  const onValueChanged = useMemo(() => (e: ChangeEvent<HTMLInputElement>) => {
    if (!disabled) {
      return onChange?.(e, e.target.checked);
    }
  }, [ disabled, onChange ]);

  return (
    <label htmlFor={realId} className={classNames(styles.root, className)}>
      <input
        {...restProps}
        id={realId}
        value={label}
        checked={value}
        disabled={disabled}
        onChange={onValueChanged}
        type="radio" />
      <div className={styles.icon} />
      <span className={styles.label}>
        {label}
      </span>
    </label>
  );
});

export default RadioButton;
